// extracted by mini-css-extract-plugin
export var ctaButton = "styles-module--ctaButton--06b1a";
export var designItForMeButton = "styles-module--designItForMeButton--72bf4";
export var dsContent = "styles-module--dsContent--7a41d";